import { XmlSchemaFacet } from './XmlSchemaFacet';

export class XmlSchemaMinLengthFacet extends XmlSchemaFacet {}
